module.exports = __webpack_public_path__ + "static/cosi2s-f47b6497adbe2afc7b090fe23ca4bb8f.jpg";